import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { ProduktDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/produkt-dto';
import { CreateServiceaftaleRequestDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/create-serviceaftale-request-dto';
import { tap, debounceTime, distinctUntilChanged, finalize, debounce, takeUntil, mergeMap, switchMap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, Observable, interval, of, forkJoin, defer } from 'rxjs';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';
import { LoaderService } from 'src/app/services/loader.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ProduktInformation, AbonnementInformation, KundeInformation, TilvalgInformation, PriceDialogData } from '../models';
import { ServiceAbonnementDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/service-abonnement-dto';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import {
  KundeService,
  ServiceAftaleService,
  TilvalgService,
  ProduktService,
  ServiceAbonnementService,
  HenviserService,
  PriceService,
  ModelService,
  FabrikatService,
  KreditvurderingService,
  PartnerPostnummerService,
} from 'src/app/api/services';
import { AnlaegDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/anlaeg-dto';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto } from 'src/app/api/models';
import { AmountDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/amount-dto';
import { EffektService } from 'src/app/services/aftale-helper.service';
import { effektValidator } from 'src/app/validators/effekt.validator';
import { ServiceaftaleTagDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-tag-dto';
import { FastprisaftaleCreateDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fastprisaftale-create-dto';
import { rabatValidator } from 'src/app/validators/rabat.validator';
import { EGIS_SERVICE_CALLER, MAX_INT32_VAL } from 'src/app/constants';
import { ServiceaftaleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-dto';
import { installationsDatoValidator } from 'src/app/validators/installationsdato.validator';
import { KomponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/komponent-dto';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { PartnerService } from 'src/app/api/services/partner.service';
import { GetServiceaftaleResponse } from 'src/app/api/models/OK/Egis/Service/Models/Response/get-serviceaftale-response';
import { LogicService } from 'src/app/services/logic.service';
import { abonnementValidator } from 'src/app/validators/abonnement.validator';
import moment from 'moment';
import { PriceDialogComponent } from '../price-dialog/price-dialog.component';
import { PriceComponentDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/price-component-dto';
import { OpkraevningDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/opkraevning-dto';
import { HenviserDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/henviser-dto';
import { AuthService } from 'src/app/services/auth.service';
import { ProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';
import { StamdataStatusEnum } from '../../../api/models/OK/Egis/Service/Models/Entities/Enums/stamdata-status-enum';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { fabrikatValidator } from 'src/app/validators/fabrikat.validator';
import { FabrikatDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fabrikat-dto';
import { ModelDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/model-dto';
import { modelValidator } from 'src/app/validators/model.validator';
import { KreditvurderingDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvurdering-dto';
import { KreditvaerdigEnumDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kreditvaerdig-enum-dto';
import { PostnummerServicePartnerEntity } from 'src/app/api/models/OK/Egis/Service/Models/Entities/postnummer-service-partner-entity';
import { PartnersPossibleDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partners-possible-dto';
import { PartnerServiceProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/partner-service-produkt-enum';

@Component({
  selector: 'app-create-aftale',
  templateUrl: './create-aftale.component.html',
  styleUrls: ['./create-aftale.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CreateAftaleComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper;

  tags: ServiceaftaleTagDto[];
  products: ProduktDto[];
  subscribtions: ServiceAbonnementDto[];
  subscription: ServiceAbonnementDto = {};
  tilvalgGroups: TilvalgGroupDto[];

  produkt: ProduktDto;
  serviceaftale: ServiceaftaleDto;
  partners: PostnummerServicePartnerEntity[];
  henvisere: HenviserDto[];

  kunde: KundeDto;
  kreditvurdering: KreditvurderingDto;
  kreditvurderingEnum: typeof KreditvaerdigEnumDto = KreditvaerdigEnumDto;
  okKundeAftaleNr: number;
  okKundeAftaleNrChanged: Subject<string> = new Subject<string>();

  kundeForm: UntypedFormGroup;
  produktForm: UntypedFormGroup;
  abonnementForm: UntypedFormGroup;
  tilvalgForm: UntypedFormGroup;
  sendLetterForm: UntypedFormGroup;

  formValues$: Observable<{
    kundeInformation: KundeInformation;
    produktInformation: ProduktInformation;
    abonnementInformation: AbonnementInformation;
    tilvalgInformation: TilvalgInformation;
  }>;

  kundeInformation: KundeInformation;
  produktInformation: ProduktInformation;
  abonnementInformation: AbonnementInformation;
  tilvalgInformation: TilvalgInformation = {
    tilvalg: [],
    fastPrisEnabled: false,
    fastPris: null,
    fixedPriceStartDate: new Date(),
    fixedPriceEndDate: null,
    rabatEnabled: false,
    rabatKontant: null,
    rabatProcent: null,
    rabatTekst: null,
    rabatSplit: null,
    isEngangsRabat: null,
    rabatkampagne: null,
  };

  fabrikater: FabrikatDto[] = [];
  selectedFabrikat: FabrikatDto;
  modeller: ModelDto[] = [];
  selectedModel: ModelDto;

  totalPrice: AmountDto;
  basePrice: AmountDto;
  listPrice: AmountDto;
  pricesWithoutMoms: boolean = false;
  priceComponents: PriceComponentDto[];
  opkraevning: OpkraevningDto;

  unsubscribe$ = new Subject<void>();

  validationErrors: any[] = [];

  g4Error: string;

  defaultOpkraevningsDate: Date = new Date();

  isLoading: boolean;

  canSeePriceInfo: boolean = false;

  isanlaegNewlyInstalled: boolean;

  selectedPartner: PostnummerServicePartnerEntity;
  newStartDate: Date = new Date();

  get opkraevningDate() {
    return this.abonnementForm?.get('opkraevningDate');
  }

  get installationDate() {
    return this.produktForm?.get('installationDate');
  }

  get garantiPeriode() {
    return this.produktForm?.get('garantiPeriode');
  }

  get startDate() {
    return this.abonnementForm?.get('startDate');
  }

  get nextCheckupDate() {
    return this.abonnementForm?.get('nextCheckupDate');
  }

  get sendLetter() {
    return this.sendLetterForm.get('sendLetter');
  }

  get produktId() {
    return this.produktForm.get('produktId');
  }

  get fabrikatId() {
    return this.produktForm.get('fabrikatId');
  }

  get modelId() {
    return this.produktForm.get('modelId');
  }

  constructor(
    private serviceAftaleService: ServiceAftaleService,
    private priceService: PriceService,
    private tilvalgService: TilvalgService,
    private router: Router,
    private kundeService: KundeService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
    private produktService: ProduktService,
    private serviceAbonnementService: ServiceAbonnementService,
    private errorHandler: ErrorHandlerService,
    private effektService: EffektService,
    private henviserService: HenviserService,
    private logic: LogicService,
    private auth: AuthService,
    private notifications: NotificationService,
    private modelService: ModelService,
    private fabrikatService: FabrikatService,
    private kreditvurderingService: KreditvurderingService,
    private partnerPostnummerService: PartnerPostnummerService,
  ) {
    this.canSeePriceInfo = this.auth.isAdministrator || this.auth.isSuperuser;
    this.okKundeAftaleNrChanged.pipe(debounceTime(300), distinctUntilChanged()).subscribe(() => {});
  }

  ngOnInit(): void {
    this.loader.loadingStateChanged$.subscribe((isloading) => (this.isLoading = isloading));

    //Default 30 days from now
    this.defaultOpkraevningsDate.setDate(this.defaultOpkraevningsDate.getDate() + 30);

    this.getTags();

    this.kundeForm = this.formBuilder.group({
      okKundeAftaleNr: ['', [Validators.required, Validators.minLength(1), Validators.max(MAX_INT32_VAL)]],
    });

    this.produktForm = this.formBuilder.group(
      {
        produktId: [null, Validators.required],
        unknownFabrikat: false,
        unknownModel: false,
        modelId: [null],
        alternativFabrikat: [''],
        alternativModel: [''],
        installationDate: [null, installationsDatoValidator],
        effekt: ['', [Validators.pattern(this.effektService.effektPattern), effektValidator]],
        driftformId: [''],
        fabrikatId: [null],
        kondenserende: [null],
        storbraender: [null],
        garantiPeriode: [null, Validators.max(MAX_INT32_VAL)],
        serienummer: [''],
        komponenter: this.formBuilder.array([]),
        installatoerId: [''],
        alternativInstallatoer: [''],
      },
      { validators: [fabrikatValidator, modelValidator] },
    );
    this.abonnementForm = this.formBuilder.group(
      {
        partnerNo: [null, Validators.required],
        henviserCvr: [null],
        abonnementId: [null, Validators.required],
        startDate: [new Date(), Validators.required],
        nextCheckupDate: [this.logic.calculateDefaultCheckupDate(new Date()), Validators.required],
        opkraevningDate: [this.defaultOpkraevningsDate, Validators.required],
        serviceOrderNote: ['', Validators.maxLength(500)],
        fastOrdreNote: ['', Validators.maxLength(500)],
        tagIds: [null],
        opkraevningsinterval: [null],
        eftersynInterval: [null],
      },
      {
        validators: abonnementValidator,
      },
    );
    this.tilvalgForm = this.formBuilder.group(
      {
        fastPrisEnabled: [false],
        fastPris: [null, [Validators.min(0), Validators.max(MAX_INT32_VAL)]],
        fixedPriceStartDate: [new Date()],
        fixedPriceEndDate: [null],
        tilvalgGroups: this.formBuilder.array([]),
        rabatEnabled: [false],
        rabatKontant: [null, [Validators.min(1), Validators.max(MAX_INT32_VAL)]],
        rabatProcent: [null, [Validators.min(1), Validators.max(100)]],
        rabatTekst: [null, [Validators.maxLength(20)]],
        rabatSplit: [null, [Validators.required]],
        engangsRabat: [null],
        rabatkampagne: [],
      },
      { validator: rabatValidator },
    );

    this.kundeForm.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe((kundeInformation) => {
      this.kundeInformation = kundeInformation;
    });

    this.produktForm.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe((produktInformation) => {
      this.produktInformation = produktInformation;
      this.produktInformation.effekt = this.effektService.getEffekt(produktInformation.effekt);
      this.isanlaegNewlyInstalled = this.isAnlaegInstalled(
        this.produktInformation?.installationDate,
        this.abonnementInformation?.nextCheckupDate,
      );

      this.produktInformation.komponenter.forEach((komponent: KomponentDto) => {
        komponent.installationDate = komponent.installationDate ? new Date(komponent.installationDate).toOkDateString() : null;
      });
    });

    this.produktForm.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        debounce(() => interval(750)),
      )
      .subscribe(() => {
        this.updatePrice();
      });

    this.produktId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        mergeMap((val) => {
          return this.fabrikatService.getFabrikaterForProdukt({ produktId: val, caller: EGIS_SERVICE_CALLER });
        }),
      )
      .subscribe((fabrikater: FabrikatDto[]) => {
        this.fabrikater = fabrikater;
      });

    this.fabrikatId.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        mergeMap((val) => {
          this.selectedFabrikat = this.fabrikater.find((x) => x.id == val);
          return this.modelService.getModellerForFabrikat({ fabrikatId: val, caller: EGIS_SERVICE_CALLER });
        }),
      )
      .subscribe((modeller: ModelDto[]) => {
        this.modeller = modeller;
      });

    this.modelId.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe((modelId: number) => {
      this.selectedModel = this.modeller.find((x) => x.id == modelId);
    });

    this.abonnementForm.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe((abonnementInformation) => {
      this.abonnementInformation = abonnementInformation;
      this.isanlaegNewlyInstalled = this.isAnlaegInstalled(
        this.produktInformation.installationDate,
        this.abonnementInformation.nextCheckupDate,
      );
    });

    this.abonnementForm.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        debounce(() => interval(750)),
      )
      .subscribe(() => {
        const startDate = this.abonnementForm.controls['startDate'];
        const fixedPriceStartDate = this.tilvalgForm.controls['fixedPriceStartDate'];
        const fixedPriceEndDate = this.tilvalgForm.controls['fixedPriceEndDate'];

        if (fixedPriceStartDate.value < startDate.value) {
          fixedPriceStartDate.setValue(startDate.value);
        }

        if (fixedPriceEndDate.value && fixedPriceEndDate.value < startDate.value) {
          fixedPriceEndDate.setValue(startDate.value);
        }

        this.updatePrice();
      });

    this.tilvalgForm.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe((tilvalgInformation) => {
      this.tilvalgInformation.tilvalg = tilvalgInformation.tilvalgGroups;
      this.tilvalgInformation.fastPris = tilvalgInformation.fastPris;
      this.tilvalgInformation.fastPrisEnabled = tilvalgInformation.fastPrisEnabled;
      this.tilvalgInformation.fixedPriceEndDate = tilvalgInformation.fixedPriceEndDate;
      this.tilvalgInformation.fixedPriceStartDate = tilvalgInformation.fixedPriceStartDate;
      this.tilvalgInformation.rabatEnabled = tilvalgInformation.rabatEnabled;
      this.tilvalgInformation.rabatKontant = tilvalgInformation.rabatKontant;
      this.tilvalgInformation.rabatProcent = tilvalgInformation.rabatProcent;
      this.tilvalgInformation.rabatTekst = tilvalgInformation.rabatTekst;
      this.tilvalgInformation.rabatSplit = tilvalgInformation.rabatSplit;
      this.tilvalgInformation.isEngangsRabat = tilvalgInformation.engangsRabat;
      this.tilvalgInformation.rabatkampagne = tilvalgInformation.rabatkampagne;
    });

    this.tilvalgForm.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        distinctUntilChanged(),
        debounce(() => interval(750)),
      )
      .subscribe(() => {
        this.updatePrice();
      });

    this.sendLetterForm = this.formBuilder.group({
      sendLetter: [true, Validators.required],
    });

    this.garantiPeriode.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe((val) => {
      this.setOpkraevningsdate();
    });

    this.startDate.valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged()).subscribe(() => {
      this.setOpkraevningsdate();
    });

    this.route.queryParams
      .pipe(
        mergeMap((params: any) => {
          this.kunde = null;
          if (!params['okKundeAftaleNr']) {
            return of(null);
          }
          const okKundeAftaleNr = params['okKundeAftaleNr'];
          this.okKundeAftaleNr = okKundeAftaleNr;
          this.kundeForm.setValue({ okKundeAftaleNr: okKundeAftaleNr });
          return this.getServiceaftaler$;
        }),
      )
      .subscribe((response: GetServiceaftaleResponse) => {
        if (response) {
          this.serviceaftale = response.serviceaftale;
        }
        if (response && !response.serviceaftale && this.okKundeAftaleNr) {
          this.getKunde(this.okKundeAftaleNr);
        }
      });
  }

  getServiceaftaler$ = defer(() => {
    this.loader.show();
    return this.serviceAftaleService
      .getServiceAftaleForKunde({
        caller: EGIS_SERVICE_CALLER,
        okKundeAftaleNr: this.okKundeAftaleNr,
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        }),
      );
  });

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  setOpkraevningsdate() {
    const defaultOpkraevningDate = moment(this.startDate.value < new Date() ? new Date() : this.startDate.value)
      .add(30, 'day')
      .toDate();
    this.opkraevningDate.setValue(defaultOpkraevningDate);
    this.opkraevningDate.setValidators(Validators.required);
    this.opkraevningDate.updateValueAndValidity();
  }

  getTags() {
    this.loader.show();
    this.serviceAftaleService
      .getServiceaftaleTags({ caller: EGIS_SERVICE_CALLER })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
      )
      .subscribe(
        (response) => {
          this.tags = response;
        },
        (error) => this.errorHandler.HandleError(error),
      );
  }

  getKunde(okKundeAftaleNr) {
    this.loader.show();

    this.kundeService
      .getKunde({ okKundeAftaleNr, caller: EGIS_SERVICE_CALLER })
      .pipe(
        mergeMap((kunde: KundeDto) => {
          if (this.kunde) {
            this.resetProduktForm();
            this.resetAbonnementForm();
            this.resetTilvalgForm();
            this.resetSendLetterForm();
          }
          this.kunde = kunde;
          return forkJoin(
            this.produktService.getProdukter({ caller: EGIS_SERVICE_CALLER }),
            this.kreditvurderingService.getKreditVurderingForServiceaftale({
              caller: EGIS_SERVICE_CALLER,
              okKundeAftaleNr: kunde.okKundeAftaleNr,
            }),
          );
        }),
        finalize(() => {
          this.updateOkKundeAftalenrControl();
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (response: [ProduktDto[], KreditvurderingDto]) => {
          this.products = response[0];
          this.kreditvurdering = response[1];
        },
        (error: HttpErrorResponse) => {
          if (error.status == 404) {
            this.notifications.error('Kunde med KundeAftaleNr: ' + okKundeAftaleNr + ' findes ikke i G4');
          } else {
            this.errorHandler.HandleError(error);
          }
        },
      );
  }
  mapProduktEnumToPartnerServiceProduktEnum(value: ProduktEnum): PartnerServiceProduktEnum {
    const mapping: Record<ProduktEnum, PartnerServiceProduktEnum> = {
      [ProduktEnum.Gas]: PartnerServiceProduktEnum.Gas,
      [ProduktEnum.Olie]: PartnerServiceProduktEnum.Olie,
      [ProduktEnum.Varmepumpe]: PartnerServiceProduktEnum.Varmepumpe,
    };
    if (value == ProduktEnum.Gas && this.produktForm.get('storbraender').value == true) {
      return PartnerServiceProduktEnum.GasStorbraender;
    }
    return mapping[value];
  }

  onProductChange(productId?: ProduktEnum) {
    if (this.produkt != this.products.find((x) => x.id == productId) && productId != null) {
      this.produkt = this.products.find((x) => x.id == productId);
      this.resetProduktForm(productId);
    }

    this.resetAbonnementForm();

    this.loader.show();
    forkJoin(
      this.partnerPostnummerService.getPartnersPossible({
        postnummer: this.kunde.anlaegsadresse.zip,
        partnerServiceProduktEnum: this.mapProduktEnumToPartnerServiceProduktEnum(this.produkt.id),
        startdate: this.newStartDate.toOkDateString(),
        caller: EGIS_SERVICE_CALLER,
      }),
      this.henviserService.getHenvisere({
        caller: EGIS_SERVICE_CALLER,
        body: {
          searchQuery: null,
        },
      }),
      this.serviceAbonnementService.getAvailableAbonnements({
        kundeTypeId: this.kunde.kundetype.id,
        produktId: this.produkt.id,
        caller: EGIS_SERVICE_CALLER,
      }),
    )
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (responses) => {
          this.partners = responses[0].postnummerServicePartnerEntities?.sort((a, b) =>
            a.partner.name < b.partner.name ? -1 : 1,
          ) as PostnummerServicePartnerEntity[];

          this.henvisere = responses[1].filter((p) => p.henviserStatus == StamdataStatusEnum.Yes) as HenviserDto[];

          if (this.partners?.length == 1) {
            this.abonnementForm.patchValue({
              partnerNo: this.partners[0].partner.partnerNo,
            });
          }
          this.subscribtions = responses[2];
        },
        (error) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  onAbonnementChange(serviceAbonnementId: number) {
    this.subscription = this.subscribtions.find((x) => x.id == serviceAbonnementId);
    this.resetTilvalgForm();
    this.loader.show();
    (this.tilvalgService
      .getTilvalgGroupsForServiceabonnement({ serviceAbonnementId, caller: EGIS_SERVICE_CALLER })
      .pipe(
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe((tilvalg: TilvalgGroupDto[]) => {
        this.tilvalgGroups = tilvalg;
        const control = <UntypedFormArray>this.tilvalgForm.controls['tilvalgGroups'];
        control.clear();

        tilvalg.forEach(() => {
          control.push(new UntypedFormControl(null, [Validators.required]));
        });
      }),
      (error: HttpErrorResponse) => {
        this.errorHandler.HandleError(error);
      });
  }

  onSelectedPartnerChange(partner: PostnummerServicePartnerEntity) {
    this.selectedPartner = partner;
    this.resetTilvalgForm();
  }

  onStartdateChange(newStartdate: any) {
    this.newStartDate = new Date(newStartdate);
    this.onProductChange();
  }

  onKundeNrChange(text: string) {
    this.okKundeAftaleNrChanged.next(text);
  }

  private mapToAnlaeg(productInfo: ProduktInformation): AnlaegDto {
    const fabrikat = productInfo.fabrikatId ? { id: productInfo.fabrikatId, name: '' } : null;
    return productInfo
      ? {
          driftform: productInfo.driftformId ? { id: productInfo.driftformId, text: '' } : null,
          minEffekt: Number(productInfo.effekt.minEffekt),
          maxEffekt: Number(productInfo.effekt.maxEffekt),
          fabrikat: fabrikat,
          installationDate: productInfo.installationDate ? productInfo.installationDate.toOkDateString() : null,
          komponenter: productInfo.komponenter,
          kondenserende: productInfo.kondenserende,
          garantiPeriode: productInfo.garantiPeriode,
          model: productInfo.modelId ? { id: productInfo.modelId, name: '', fabrikat: fabrikat } : null,
          alternativFabrikat: productInfo.alternativFabrikat,
          alternativModel: productInfo.alternativModel,
          serienummer: productInfo.serienummer,
          storbraender: Boolean(productInfo.storbraender),
          installatoer: productInfo.installatoerId ? { id: productInfo.installatoerId, name: '', cvr: '' } : null,
          alternativInstallatoer: productInfo.alternativInstallatoer,
        }
      : null;
  }

  private buildServiceAftaleRequest(): CreateServiceaftaleRequestDto {
    const tilvalgIds = this.tilvalgInformation?.tilvalg?.filter((x) => x != null && Number.isSafeInteger(x));
    const fastpriser: FastprisaftaleCreateDto[] = [];
    if (this.tilvalgInformation?.fastPrisEnabled) {
      fastpriser.push({
        // Strip time
        endDate: this.tilvalgInformation.fixedPriceEndDate ? this.tilvalgInformation.fixedPriceEndDate.toOkDateString() : null,
        startDate: this.tilvalgInformation.fixedPriceStartDate.toOkDateString(),
        fastPrisInclMoms: this.kunde.kundetype.id == 1 ? this.tilvalgInformation.fastPris : null,
        fastPrisExclMoms: this.kunde.kundetype.id == 2 ? this.tilvalgInformation.fastPris : null,
      });
    }

    const request: CreateServiceaftaleRequestDto = {
      startDate: this.abonnementInformation?.startDate?.toOkDateString(),
      endDate: null,
      partnerNo: this.abonnementInformation?.partnerNo,
      henviserCvr: this.abonnementInformation?.henviserCvr,
      abonnementId: Number(this.abonnementInformation?.abonnementId),
      okKundeAftalenr: Number(this.kundeInformation?.okKundeAftaleNr),
      tilvalgNrList: tilvalgIds && !this.subscription.isTilkaldsabonnement ? tilvalgIds : null,
      naesteEftersynDate: this.subscription.isTilkaldsabonnement ? null : this.abonnementInformation?.nextCheckupDate?.toOkDateString(),
      serviceEftersynNote: this.abonnementInformation?.serviceOrderNote,
      fastOrdreNote: this.abonnementInformation?.fastOrdreNote,
      opkraevningDate: this.subscription.isTilkaldsabonnement ? null : this.abonnementInformation?.opkraevningDate?.toOkDateString(),
      anlaeg: this.mapToAnlaeg(this.produktInformation),
      serviceaftaleTagIds: this.abonnementInformation?.tagIds ? this.abonnementInformation.tagIds : [],
      fastprisaftaler: fastpriser,
      customRabat: {
        rabatKontantInklMoms:
          this.tilvalgInformation?.rabatEnabled && this.kunde.kundetype.id === 1 ? this.tilvalgInformation.rabatKontant : null,
        rabatKontantExclMoms:
          this.tilvalgInformation?.rabatEnabled && this.kunde.kundetype.id === 2 ? this.tilvalgInformation.rabatKontant : null,
        isEngangsRabat: this.tilvalgInformation.isEngangsRabat,
        rabatProcent: this.tilvalgInformation.rabatProcent,
        rabatTekst: this.tilvalgInformation.rabatTekst,
        partnerShare: this.tilvalgInformation.rabatSplit === -1 ? null : this.tilvalgInformation.rabatSplit,
      },
      rabatKampagneId: this.tilvalgInformation.rabatkampagne != null ? this.tilvalgInformation.rabatkampagne.id : null,
      opkraevningsinterval: this.subscription.isTilkaldsabonnement ? null : this.abonnementInformation.opkraevningsinterval,
      sendLetter: this.sendLetterForm.controls.sendLetter.value,
    };

    return request;
  }

  updatePrice() {
    this.totalPrice = null;
    this.basePrice = null;
    this.listPrice = null;
    this.opkraevning = null;
    this.priceComponents = null;

    if (this.kunde == null) {
      return;
    }
    if (this.abonnementForm.get('partnerNo').value == null) {
      return;
    }

    const request = this.buildServiceAftaleRequest();
    this.priceService
      .getPriceServiceaftale({
        caller: EGIS_SERVICE_CALLER,
        body: request,
      })
      .pipe(
        tap(() => {}),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (price: OkEgisServiceModelsDtoGetPriceServiceaftaleResponseDto) => {
          this.basePrice = price.basePrice;
          this.totalPrice = price.totalPrice;
          this.listPrice = price.listPrice;
          this.pricesWithoutMoms = !price.preferredShownWithMoms;
          this.priceComponents = price.priceComponents;
          this.opkraevning = price.opkraevning;
        },
        (error) => {
          if (error && error.error && error.error.code && error.error.code > 900000 && error.error.code < 1000000) {
            this.g4Error = error.error.message;
          }
        },
      );
  }

  onCreate() {
    this.validationErrors = [];
    const request = this.buildServiceAftaleRequest();

    this.loader.show();
    this.serviceAftaleService
      .createServiceaftale({
        caller: EGIS_SERVICE_CALLER,
        body: request,
      })
      .pipe(
        tap(() => {}),
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        () => {
          this.notifications.success('Serviceaftale oprettet.');
          this.router.navigate(['/aftale/', this.okKundeAftaleNr]);
        },
        (error: HttpErrorResponse) => {
          this.errorHandler.HandleError(error);
        },
      );
  }

  onCloseClick() {
    if (!this.kundeForm.dirty) {
      this.router.navigate(['/aftale']);
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Er du sikker?',
          body: 'Er du sikker på at du vil afbryde oprettelsen af serviceaftalen?',
        },
      });

      dialogRef.afterClosed().subscribe((confirm) => {
        if (confirm) {
          this.router.navigate(['/aftale']);
        }
      });
    }
  }

  priceInfo() {
    const data: PriceDialogData = {
      pricecomponents: this.priceComponents,
      moms: !this.pricesWithoutMoms,
      totalPrice: this.totalPrice,
      listPrice: this.listPrice,
      opkraevning: this.opkraevning,
    };
    this.dialog.open(PriceDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      data,
    });
  }

  updateOkKundeAftalenrControl(): void {
    const control = this.kundeForm.get('okKundeAftaleNr');

    if (this.kunde) {
      control.disable();
    } else {
      control.enable();
    }
  }

  reset(): void {
    this.kunde = null;
    this.kreditvurdering = null;
    this.resetKundeForm();
    this.resetProduktForm();
    this.resetAbonnementForm();
    this.resetTilvalgForm();
    this.resetSendLetterForm();
    this.updateOkKundeAftalenrControl();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
  }

  resetKundeForm(): void {
    this.kundeForm.reset({
      okKundeAftaleNr: '',
    });
  }

  resetProduktForm(productId?: ProduktEnum): void {
    this.produktForm.reset({
      produktId: productId,
      alternativFabrikat: null,
      modelId: null,
      alternativModel: null,
      installationDate: null,
      minEffekt: '',
      maxEffekt: '',
      driftformId: null,
      fabrikatId: null,
      kondenserende: null,
      storbraender: null,
      garantiPeriode: null,
      serienummer: '',
      unknownFabrikat: false,
    });

    const komponenter = this.produktForm.get('komponenter') as UntypedFormArray;
    komponenter.clear();
  }

  resetAbonnementForm(): void {
    this.abonnementForm.reset({
      abonnementId: null,
      startDate: new Date(),
      nextCheckupDate: this.logic.calculateDefaultCheckupDate(new Date()),
      opkraevningDate: this.defaultOpkraevningsDate,
      serviceOrderNote: '',
      fastOrdreNote: '',
      tags: null,
      opkraevningsinterval: null,
    });
  }

  resetTilvalgForm(): void {
    this.tilvalgForm.reset({
      fastPrisEnabled: false,
      fastPris: null,
      fixedPriceStartDate: new Date(),
      fixedPriceEndDate: null,
      rabatEnabled: false,
      rabatKontant: null,
      rabatProcent: null,
      rabatTekst: null,
      rabatSplit: null,
      engangsRabat: null,
    });
  }

  resetSendLetterForm(): void {
    this.sendLetterForm.reset({
      sendLetter: true,
    });
  }

  reloadKundeinformation() {
    this.loader.show();
    this.kundeService
      .getKunde({ okKundeAftaleNr: this.kunde.okKundeAftaleNr, caller: EGIS_SERVICE_CALLER })
      .pipe(
        mergeMap((kunde: KundeDto) => {
          this.kunde = kunde;
          return this.kreditvurderingService.getKreditVurderingForServiceaftale({
            caller: EGIS_SERVICE_CALLER,
            okKundeAftaleNr: kunde.okKundeAftaleNr,
          });
        }),
        finalize(() => {
          this.loader.hide();
        }),
        takeUntil(this.unsubscribe$),
      )
      .subscribe(
        (kreditvurdering: KreditvurderingDto) => {
          this.kreditvurdering = kreditvurdering;
        },
        (error) => this.errorHandler.HandleError(error),
      );
  }

  getTilvalgSummary(index: number, tilvalgnr: number) {
    var tilvalgGroup = this.tilvalgGroups[index];
    var tilvalg = tilvalgGroup.tilvalg.find((x) => x.tilvalgnr == tilvalgnr);
    return `${tilvalgGroup.name}: ${tilvalg.name}`;
  }

  isAnlaegInstalled(installationDate: Date, naesteEftersynDate: Date) {
    const years = moment(naesteEftersynDate).diff(installationDate, 'years');
    return years < 1;
  }
}
